module.exports = __webpack_public_path__ + "img/5.1c37c29c.jpg";